import { render, staticRenderFns } from "./Spasticity.vue?vue&type=template&id=5095f2a6&scoped=true"
import script from "./Spasticity.vue?vue&type=script&lang=js"
export * from "./Spasticity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5095f2a6",
  null
  
)

export default component.exports